"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSimType = exports.OrderShippingMode = exports.OrderPaymentMode = void 0;
/**
 * Enum für den Parameter order_payment_mode
 */
var OrderPaymentMode;
(function (OrderPaymentMode) {
    OrderPaymentMode["CREDIT_CARD"] = "kreditkarte";
    OrderPaymentMode["PAYPAL"] = "paypal";
    OrderPaymentMode["SEPA"] = "sepa";
    OrderPaymentMode["GIROPAY"] = "giropay";
    OrderPaymentMode["GOOGLE_PAY"] = "google-pay";
    OrderPaymentMode["APPLE_PAY"] = "apple-pay";
    OrderPaymentMode["NACHNAHME"] = "nachnahme";
    OrderPaymentMode["PREPAID_CREDIT"] = "guthaben";
    OrderPaymentMode["POSTPAID"] = "postpaid";
    OrderPaymentMode["NO_PAYMENT"] = "keine-zahlung";
    OrderPaymentMode["HAENDLER"] = "haendler";
})(OrderPaymentMode || (exports.OrderPaymentMode = OrderPaymentMode = {}));
/**
 * Enum für den Parameter order_shipping_mode
 */
var OrderShippingMode;
(function (OrderShippingMode) {
    OrderShippingMode["NO_SHIPPING"] = "kein-versand";
    OrderShippingMode["POSTAL_ADDRESS"] = "postadresse";
    OrderShippingMode["PACKSTATION"] = "packstation";
    OrderShippingMode["SOFORTABHOLUNG"] = "sofortabholung";
})(OrderShippingMode || (exports.OrderShippingMode = OrderShippingMode = {}));
var OrderSimType;
(function (OrderSimType) {
    OrderSimType["ESIM"] = "esim";
    OrderSimType["TRIPLE_SIM"] = "triple_sim";
})(OrderSimType || (exports.OrderSimType = OrderSimType = {}));
